export default __webpack_public_path__ + "static/media/1259.5913f6d4.png";